// extracted by mini-css-extract-plugin
export default {"cls1":"WXlSlXByGIKmkOV5EsNX","cls2":"B97Xa01tL4iqh1BvwRxw WXlSlXByGIKmkOV5EsNX"};